import Header from '../Header'
import Footer from '../Footer'
import Head from '../Head'
import * as common from '../../common/commonFunction'
import cookie from '../../common/cookieManager'
import commonSession from "../../common/commonSession"
import { setCookie, getCookie } from 'cookies-next';
import { useSpring, animated } from 'react-spring';
import { useEffect, useState } from 'react';
import { FUNDING_AGREE_TITLE, FUNDING_AGREE_CONTENT } from "../../lib/global_variable"
import $ from 'jquery';
import axios from 'axios'
import { isMobile } from "react-device-detect";

const CouponModal = (prop) => {

    var sessionInfo = commonSession.getSession()
    const auth = "Bearer " + sessionInfo.token;

    const [active, setActive] = useState('');
    const [code, setCode] = useState('');

    function toggleBtn() {
        if ($('.swiper-agree-btn').hasClass('active')) {
            setActive('');
        } else {
            setActive('active');
        }
    }


    // 덕스티켓 이벤트 관련 쿠폰 등록 기능 추가 -- kjy 
    const setCouponData = async () => {

        if (active == '') {
            alert('서비스 이용에 동의해 주세요.');
            return false;
        }

        const option = {
            url: "/voucher/issue",
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            },
            data: {
                "code": code,
                "memberId": sessionInfo.uid,
            }
        }

        axios(option)
            .then(async response => {
                if(response.data.result){
                        alert('쿠폰 등록을 완료하였습니다');
                        window.location.reload();
                }else{
                    if(response.data.reason){
                        alert(response.data.reason)
                    }
                }
            });
    }

    const handleChange = (e) => {
        setCode(e.target.value)
    };


    return (
        <>
            {isMobile ? <link rel='stylesheet' href='/css/mobile/funding-modal.min.css' /> : <link rel='stylesheet' href='/css/funding-modal.min.css' />}
            <div className="container w-100 text-center m-0">
                <div className="modal" id="fundingModalPopup">
                    <div className="modal_body w-80">
                        <p className="funding-modal-title">쿠폰 등록</p>
                        <p className="fundinb-sub-title">사용자 이용 약관을 반드시 확인해 주세요.</p>
                        <div className="agree-content">
                            <p className="title">{FUNDING_AGREE_TITLE}</p>
                            <div className="agree-text" dangerouslySetInnerHTML={{ __html: FUNDING_AGREE_CONTENT }}>
                            </div>
                        </div>
                        <div className="agree-box">
                            <div className="agree-text">
                                <p>서비스 이용 약관에 동의합니다</p>
                            </div>
                            <div className="agree-btn-box">
                                <i className={`swiper-agree-btn ` + active} onClick={toggleBtn}></i>
                            </div>
                        </div>
                        <div className="notice-box">
                            <p>- 본 작품이 웹툰으로 제작되는 과정에 커뮤니티의 일원으로 참여 할 수 있습니다.</p>
                            <p>- 웹툰이 2차, 3차 저작물로 제작될 때 구매하신 참여 티켓에 비례하여 저작권을 획득 할 수 있습니다.</p>
                        </div>
                        <div className="buy-box" style={{display:"block"}}>
                            <p className="buy-cnt">쿠폰코드 : <input type="text" className="primary-red w-80" id="coupon-code" name="coupon_code" value={code} onChange={handleChange} /></p>
                        </div>
                        <div className="btn-box">
                            <button type="button" className="primary-btn primary-red" style={{ marginRight: "10px" }} onClick={() => $('#fundingModalPopup').css('display', 'none')}>닫기</button>
                            <button type="button" className="primary-btn primary-red" onClick={() => setCouponData()}>등록하기</button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default CouponModal;